import { AbstractContentState, useCmsContent } from '@cp-shared-19/frontend-integration';
import { fetchMarketingCard } from './MarketingCardSlice';
import { MarketingCardContentSelector } from './MarketingCardContentSelector';
import { MarketingCard } from './utils';

export function useMarketingCard(): AbstractContentState<MarketingCard> {
    return useCmsContent(fetchMarketingCard, MarketingCardContentSelector);
}
